import React from 'react';
import styled from "styled-components";
import brodacka from "../../Assets/FinalWorks/brodacka.jpg"
import brzezicki from "../../Assets/FinalWorks/brzezicki.jpg"
import doseth from "../../Assets/FinalWorks/doseth.jpg"
import kim from "../../Assets/FinalWorks/kim.jpg"
import jiang from "../../Assets/FinalWorks/jiang.jpg"
import li from "../../Assets/FinalWorks/li.jpg"
import lee from "../../Assets/FinalWorks/lee.jpg"
import pan from "../../Assets/FinalWorks/pan.jpg"
import salvo from "../../Assets/FinalWorks/salvo.jpg"
import francuzik from "../../Assets/FinalWorks/francuzik.jpg"
import ledzwa from "../../Assets/FinalWorks/ledzwa.jpg"
import stanczak from "../../Assets/FinalWorks/stanczak.jpg"

const Voting = () => {


    return (
        <Wrapper>
            <h1>Grand Prix</h1>
            <img src={brodacka}/>
            <p>Natalia Brodacka | Poland</p>
            <h1>Awards</h1>
            <Awards>
                <div>
                    <h3>1st prize</h3>
                    <img src={pan}/>
                    <p>Manuel Dal Pan | Italy</p>
                </div>
                <div>
                    <h3>2nd prize</h3>
                    <img src={lee}/>
                    <p>Daeun Lee | South Korea</p>
                </div>
                <div>
                    <h3>3rd prize</h3>
                    <img src={jiang}/>
                    <p>Guoping Jiang | China</p>
                </div>
                <div>
                    <h3>Distinction</h3>
                    <img src={francuzik}/>
                    <p>Sandra Francuzik | Poland</p>
                </div>
            </Awards>
            <h1>Honourable Mentions</h1>
            <Mentions>
                <div>
                    <img src={salvo}/>
                    <p>Simone Di Salvo | Italy</p>
                </div>
                <div>
                    <img src={kim}/>
                    <p>Su A Kim | South Korea</p>
                </div>
                <div>
                    <img src={li}/>
                    <p>Bingrui Li | China/Belgium</p>
                </div>
                <div>
                    <img src={brzezicki}/>
                    <p>Kacper Brzezicki | Poland</p>
                </div>
                <div>
                    <img src={stanczak}/>
                    <p>Karolina Stańczak | Poland</p>
                </div>
                <div>
                    <img src={doseth}/>
                    <p>Jakub Doseth | Germany</p>
                </div>
                <div>
                    <img src={ledzwa}/>
                    <p>Agata Ledzwa | Poland</p>
                </div>
            </Mentions>

        </Wrapper>
    )

}

export default Voting


const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  position: relative;
  top: 100px;
  padding: 100px;

  h1 {
    padding: 0;
    margin: 30px;
    color: #ffc140;
  }
  
  img {
    width: 300px;
    height: auto;
  }
}
`

const Awards = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 0 100px;

  img {
    width: 200px;
    height: auto;
    margin-bottom: 30px;
    margin-right: 30px;
  }
`

const Mentions = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 0 100px;
  text-align: center;

  img {
    width: 150px;
    height: auto;
    margin: 30px;

  }
`
